import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueMask from 'v-mask'
Vue.config.productionTip = false

Vue.use(VueMask);
Vue.use(require('vue-shortkey'))
// window.__eventDebug = {
//   pointerdown: 0,
//   pointerup: 0,
//   pointercancel: 0,
//   lostpointercapture: 0,
//   mousedown: 0,
//   mouseup: 0,
//   click: 0,
//   dragstart: 0,
//   dragend: 0,
//   contextmenu: 0,
//   last: null,
//   history: []
// }

// const debugEvents = [
//   'pointerdown',
//   'pointerup',
//   'pointercancel',
//   'lostpointercapture',
//   'mousedown',
//   'mouseup',
//   'click',
//   'dragstart',
//   'dragend',
//   'contextmenu'
// ]

// debugEvents.forEach(type => {
//   window.addEventListener(type, event => {
//     window.__eventDebug[type]++

//     const info = {
//       type,
//       tag: event.target?.tagName,
//       className: event.target?.className,
//       pointerId: event.pointerId,
//       button: event.button,
//       buttons: event.buttons,
//       time: new Date().toISOString()
//     }

//     window.__eventDebug.last = info

//     window.__eventDebug.history.push(info)

//     if (window.__eventDebug.history.length > 20) {
//       window.__eventDebug.history.shift()
//     }
//   }, true)
// })
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
